import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot,Router } from '@angular/router';
import { AuthService } from './auth-service.component';
import { CookieService } from 'ngx-cookie';
import { EnvService } from '../core/env.service';
import { CustomCookieService } from '../commonservices/custom-cookie.service';

@Injectable()
export class AuthRouteGuard implements CanActivate {
    constructor(
        private _authService: AuthService,
        private _cookieService: CookieService,
        private _customCookieService: CustomCookieService,
        private _env: EnvService,
        private _router: Router,
    ) { }

    canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        return new Promise((resolve, reject) => {
            this._authService.isLoggedIn()
            .then((isLogIn) => {
                if(isLogIn && this.isAuthPages(state)){
                    resolve(true);
                }else{
                    this.redirectToLogin();
                    resolve(true);
                }
            })
            .catch(function () {
                this._router.navigate(['/login'], { replaceUrl: true });             
                reject(false);
            });
        });    
    }

    redirectToLogin(): void{
        this._customCookieService.removeAllCookiesExceptOidc();
        this._authService.logout();
        this._authService.completeLogout().then(_ => {
            this._router.navigate(['/login'], { replaceUrl: true });
        });
    }
    
    isAuthPages(state: RouterStateSnapshot): boolean {
        // check cookieservice is undefined
        if(this._cookieService.get('pages') == undefined) return false;

        var pageAccess = JSON.parse(this._cookieService.get("pages")) || [];
        var ctgfLoginToken = this._cookieService.get('__CTGFLoginGuid');

        var urlPath = (state.url).split('/');
        if(urlPath.includes('dashboard') && pageAccess.includes('ctdashboard'))  return true;
        if(urlPath.includes('eDataNew') && pageAccess.includes('edatav2'))  return true;
        if(urlPath.includes('ratesearch') && pageAccess.includes('ratesearch'))  return true;
        if(urlPath.includes('webresolution') && pageAccess.includes('webresolutionv2'))  return true;
        if(urlPath.includes('eData') && pageAccess.includes('edata'))  return true;
        if(urlPath.includes('webstore') && pageAccess.includes('webstore'))  return true;
        if(urlPath.includes('newwebstore') && pageAccess.includes('webstorev2'))  return true;
        if(urlPath.includes('rules') && pageAccess.includes('rules'))  return true;
        if(urlPath.includes('newimagearchive') && pageAccess.includes('imagearchivev2'))  return true; 
        if(urlPath.includes('ctms') && pageAccess.includes('ctms'))  return true;

        if(ctgfLoginToken == null){
            return false;
        }

        if(urlPath[0] ==  "" && urlPath[1] ==  "") //then it is a roothpath then get the default
        {
            var defaultUrl = this._cookieService.get('defaultRoute') 
            if(defaultUrl!=null)
            {
                this._router.navigate([defaultUrl], { replaceUrl: true });
                return true;
            }else
            {
                return false; //logout
            }

        }
        else{
            window.location.href = this._env.rateTrakApplicationPage;
            return false;  
        }

   
    }
}